<template>
    <BaseModal :id="'static'" :title="title" :size="'lg'">
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb" />
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="formSubmitLocal()">
                <div class="row m-0 formdynamic justify-content-md-between" style="padding-top: 10px">
                    <div class="p-0 formdynamic__item col-md-12" :style="`margin-top:20px`">
                        <div class="formdynamic__item__field">
                            <label v-html="`Notes <b style='color:red;'>*</b>`" class="modal-label" />
                            <textarea required class="" style="" rows="4" v-model="form_data.note" />
                        </div>
                    </div>
                    <div class="p-0 formdynamic__item col-md-2" :style="`margin-top:20px`">
                        <div class="formdynamic__item__field">
                            <label v-html="`Order`" class="modal-label" />
                            <input type="number" v-model="form_data.order" />
                        </div>
                    </div>
                    <div class="p-0 formdynamic__item col-md-2" :style="`margin-top:20px`">
                        <div class="formdynamic__item__field">
                            <label v-html="`Minutes <b style='color:red;'>*</b>`" class="modal-label" />
                            <input required type="number" v-model="form_data.minutes" step=".01" />
                        </div>
                    </div>
                    <div class="p-0 formdynamic__item col-md-2" :style="`margin-top:20px`">
                        <div class="formdynamic__item__field">
                            <label v-html="`Include in statuses`" class="modal-label mb-2"
                                style="display: block; font-size: 12px" />
                            <div class="custom-control custom-checkbox position-absolute" style="bottom: 0">
                                <input type="checkbox" class="custom-control-input" v-model="form_data.include_in_statuses"
                                    id="include_in_statuses" />
                                <label for="include_in_statuses" class="custom-control-label ml-2" />
                            </div>
                        </div>
                    </div>

                    <div class="p-0 formdynamic__item col-md-6" :style="`margin-top:20px`">
                        <div class="formdynamic__item__field">
                            <span class="row m-0">
                                <div v-for="(val, i) in days" :key="i" style="padding-right: 1.4rem">
                                    <label v-html="`${val.name}`" class="modal-label mb-2"
                                        style="display: block; font-size: 12px" />
                                    <div class="custom-control custom-checkbox position-absolute" style="bottom: 0">
                                        <input type="checkbox" class="custom-control-input" v-model="form_data.days"
                                            :value="val.id" :id="val.id" />
                                        <label :for="val.id" class="custom-control-label ml-2" />
                                    </div>
                                </div>
                            </span>
                        </div>
                    </div>

                    <div class="p-0 formdynamic__item col-md-12" :style="`margin-top:20px`" v-if="!for_update">
                        <div class="formdynamic__item__field">
                            <div class="mb-0 no-gutters">
                                <label v-html="`Daily Asssignments:`" class="modal-label mb-3" style="display: block" />
                                <v-card>
                                    <DinamicTable :ref="'dinamicTableNote'" :headers="table_headers"
                                        :items="local_daily_assignments" :search="search" :checkable="true"
                                        :selectable_columns="false" :not_show_footer="true" name="dinamicTableNoteDuty"
                                        size="24" />
                                </v-card>
                            </div>
                        </div>
                    </div>
                </div>
                <CentralButtons v-if="!for_update"/>
                <CentralLiteButtons v-else/>
            </form>
        </template>
    </BaseModal>
</template>

<script>
import FormResources from "./form_resources";
import Resources from "./resources";
//   import FormDynamic      from    '@/components/FormDynamic.vue'
import Breadcrumb from "@/components/BreadcrumbComponent/Breadcrumb";
import BaseModal from "@/components/BaseModal";
import CentralButtons from "@/components/CentralButtons";
import CentralLiteButtons from "@/components/CentralLiteButtons";
import DinamicTable from "@/components/DinamicTable";

export default {
    name: "FormModalDutyNote",
    props: ["parent", "notyf", "array_options", "daily_assignments_collection", "count_assignments"],

    components: {
        //   FormDynamic,
        Breadcrumb,
        BaseModal,
        CentralButtons,
        CentralLiteButtons,
        DinamicTable,
    },

    data() {
        return {
            rest_api: "assignment_duty_notes",
            form_data: FormResources.form_data_duty_note,
            form_backup: { ...FormResources.form_data_duty_note },
            table_headers: Resources.note_duty_table_headers,
            days: FormResources.days,
            title: "Duty Note",
            search: "",
            breadcrumb: Resources.breadcrumb,
            local_daily_assignments: [],
            for_update: false,
        };
    },

    watch: {
        daily_assignments_collection: {
            handler: function () {
                // this.form_data.daily_assignments = this.daily_assignments_collection.forEach(assignment => assignment.checked = true)
            },
            deep: true,
        },
    },

    methods: 
    {
        async startModal(form_data = null, i = -1) 
        {
            this.count_assignments = 0

            if(form_data)
            {
                const { room, sunday, monday, tuesday, wednesday, thursday, friday, saturday } = form_data;

                const days = [];

                if (sunday) days.push(7);
                if (monday) days.push(1);
                if (tuesday) days.push(2);
                if (wednesday) days.push(3);
                if (thursday) days.push(4);
                if (friday) days.push(5);
                if (saturday) days.push(6);

                form_data['note']  = room
                form_data['days']  = days
                form_data['order'] = i + 1

                this.form_data = {...form_data}

                this.for_update = true;

                const response = await this.get(`${this.rest_api}_count/${form_data.assignment_duty_note_id}`)

                if(response.status)
                {
                    this.count_assignments = response.data
                }
            }
            else
            {
                this.for_update = false
                this.form_data = {...this.form_backup}
            }

            this.local_daily_assignments = JSON.parse(
                JSON.stringify(this.daily_assignments_collection)
            );

            let index = this.local_daily_assignments.findIndex(
                (item) => item.id === this.parent.id
            )

            if (index >= 0) 
            {
                this.local_daily_assignments[index].checked = true;
            }
        },
        async formSubmitLocal() 
        {
            if(!this.for_update)
            {
                this.form_data.daily_assignments = this.local_daily_assignments.filter(
                    (assignment) => assignment.checked === true
                );
                if (!this.form_data.daily_assignments.length) {
                    this.notyf.error("Select at least one daily assignment");
                    return;
                }
                await this.form_submit();
                this.$emit("reloaded", {});
            }
            else
            {
                window.$(`#static`).modal('hide')

                if(this.count_assignments > 1)
                {
                    setTimeout(() => {
                        window.$(`#static-confirmation-duty-note`).modal('show')
                    }, 300);
                }
                else
                {
                    this.$emit('updateDutyNote', {edit_all: false})
                }
            }
        },
    },

    mounted() { },
};
</script>
